
import { Component, Inject, Vue } from 'vue-property-decorator';
import GeneralScaffold from '@/components/GeneralScaffold.vue';
import PagedDataTable from '@/components/PagedDataTable.vue';
import LibraryItemRepository from '@/repositories/libraryitem/LibraryItemRepository';

@Component({
    components: { GeneralScaffold, PagedDataTable },
})
export default class LabelListScreen extends Vue {
    @Inject()
    private readonly libraryItemRepository!: LibraryItemRepository;

    public get headers(): any[] {
        return [
            {
                text: this.$t('general.actions'),
                value: 'action',
                sortable: false,
            },
            {
                text: this.$t('crud.library-item.defaultSubject'),
                align: 'left',
                value: 'defaultSubject',
                sortable: true,
            },
            {
                text: this.$t('crud.library-item.type'),
                value: 'type',
                sortable: true,
            },
        ];
    }
}
